/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    DeliveryItemsService: JS5Object,
    EnumService: JS5Object,
    MetadataService: JS5Object,
    NotificationService: JS5Object,
    PackageAcceptTemplatesService: JS5Object,
    PartnerEditService: JS5Object,
    SidebarService: JS5Object,
) {
    const getFormData = () => {
        return $q.all({
            packageAcceptTemplate: PackageAcceptTemplatesService.getPackageAcceptTemplate(this.resolveData.deliveryProfilePackageAcceptTemplateId),
            deliveryItemEditViewFormData: DeliveryItemsService.getDeliveryItemEditViewFormData($routeParams.id)
        }).then((data: JS5Object) => {
            // Delivery Item Form Data
            this.assetContentTemplates = data.deliveryItemEditViewFormData.assetContentTemplates;

            this.macCaptionTemplates = data.deliveryItemEditViewFormData.macCaptionTemplates;
            this.packageAcceptTemplate = data.packageAcceptTemplate;
            this.mediaAcceptProfiles = data.deliveryItemEditViewFormData.mediaAcceptProfiles;
            this.languages = _.chain(data.deliveryItemEditViewFormData.languages)
                .partition({isDefault: true})
                .flatten()
                .value();
            this.roles = data.deliveryItemEditViewFormData.roles;
            this.deliveryEndpointsForPartner = data.deliveryItemEditViewFormData.deliveryEndpointsForPartner;
            this.transformTemplates = data.deliveryItemEditViewFormData.transformTemplates;
            this.conditionalTemplates = data.deliveryItemEditViewFormData.conditionalTemplates;
            this.mediaConversionTemplates = data.deliveryItemEditViewFormData.mediaConversionTemplates;
            getVisiblePanels();
            return data;
        }).catch((error: JS5Object) => {
            NotificationService.createFailureNotification('Error getting Delivery Item Form Data');
            console.warn(error);
        });
    };

    const getVisiblePanels = () => {
        this.visiblePanels = DeliveryItemsService.getVisibleEditViewPanels($routeParams.deliveryItemType);
    };

    const getDeliveryItem = () => {
        return PartnerEditService.getDeliveryItem(
            $routeParams.deliveryItemId
        ).then((deliveryItem: JS5Object) => {
            // Delivery Item
            PartnerEditService.originalEditData = _.cloneDeep(deliveryItem);
            return _.cloneDeep(deliveryItem);

        }).catch((error: JS5Object) => {
            NotificationService.createFailureNotification('Error getting Delivery Item');
            console.warn(error);
        });
    };

    this.onMediaConversionTemplateTypeChanged = (type: string) => {
        this.mediaConversionTemplateType = type;
    };

    const prepareEditDataForSave = () => {
        this.editData.deliveryProfileId = $routeParams.deliveryProfileId;
        if (this.mediaConversionTemplateType !== 'Vantage') {
            delete this.editData.vantageCompositionFlag;
            delete this.editData.vantageCompositionProcessorName;
            delete this.editData.fadeInSeconds;
            delete this.editData.fadeOutSeconds;
            delete this.editData.startTimecodeExpression;
            delete this.editData.nielsenDisabledFlag;
            delete this.editData.nexGuardDisabledFlag;
        }
        if (!this.mediaConversionTemplateType) {
            console.warn('No FFmpeg, Vantage, or Passthrough Template set before save');
        }
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        prepareEditDataForSave();
        if ($routeParams.deliveryItemId === '-1') {
            saveNewDeliveryItem();
        } else {
            updateDeliveryItem();
        }
    };

    const updateDeliveryItem = () => {
        PartnerEditService.updateDeliveryItem(this.editData).then((deliveryItem: JS5Object) => {
            PartnerEditService.originalEditData = _.cloneDeep(deliveryItem);
            this.editData = _.cloneDeep(deliveryItem);
            this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(this.editData.metadata.properties);
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveNewDeliveryItem = () => {
        this.editData.sourceVideoAcceptProfile = this.resolveData.mediaAcceptProfile;
        PartnerEditService.createDeliveryItem(this.editData).then((deliveryItem: JS5Object) => {
            this.editData = _.cloneDeep(deliveryItem);
            this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(this.editData.metadata.properties);
            $route.updateParams({deliveryItemId: deliveryItem.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => {
                let formDirty: boolean = !_.get(this.editorForm, '$pristine');
                let allFieldsValid: boolean = _.get(this.editorForm, '$valid');
                return formDirty && allFieldsValid;
            },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                if ($routeParams.deliveryItemId === '-1') {
                    $location.url(`/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}`)
                        .search({tab: $routeParams.deliveryItemType});
                } else {
                    this.editData = _.cloneDeep(PartnerEditService.originalEditData);
                    this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(this.editData.metadata.properties);
                    this.editorForm.$setPristine();
                }
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => {
                $location.url(`/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}`)
                    .search({tab: $routeParams.deliveryItemType});
            }
        }
    ];

    const setupBreadcrumbs = () => {
        const breadCrumbSize = _.size(BreadcrumbService.getBreadcrumbs());
        if (breadCrumbSize === 0 || breadCrumbSize === 1) {
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.partnerName,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles`
            });
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}`,
                params: {tab: 'deliveryItems'}
            });
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.mediaAcceptProfile.name,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}`,
                params: {tab: $routeParams.deliveryItemType}
            });
        } else if (breadCrumbSize === 2) {
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}`,
                params: {tab: 'deliveryItems'}
            });
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.mediaAcceptProfile.name,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}`,
                params: {tab: $routeParams.deliveryItemType}
            });
        } else if (breadCrumbSize === 3) {
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.mediaAcceptProfile.name,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}`,
                params: {tab: $routeParams.deliveryItemType}
            });
        }
    };

    this.$onInit = () => {
        SidebarService.editService = DeliveryItemsService;
        this.deliveryItemType = $routeParams.deliveryItemType;
        this.mediaConversionTemplateType = null;
        this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };

        EnumService.queryForEnums().then(() => {
            setupBreadcrumbs();

            let pendingEditData: JS5Object;
            let editViewPromises = [];
            if ($routeParams.deliveryItemId === '-1') {
                pendingEditData = {
                    type: $routeParams.deliveryItemType,
                    metadata: {
                        modified: false,
                        properties: {},
                    }
                };
                switch ($routeParams.deliveryItemType) {
                    case 'Image':
                        pendingEditData.sourceType = 'PACKAGE_IMAGE';
                        pendingEditData.languages = [];
                        break;
                    case 'Artwork':
                        pendingEditData.type = 'Image';
                        pendingEditData.sourceType = 'ARTWORK_IMAGE';
                        break;
                    case 'CC':
                    case 'Subtitle':
                    case 'Audio':
                        pendingEditData.roles = [];
                        pendingEditData.languages = [];
                        break;
                    default:
                        break;
                }
                editViewPromises.push(getFormData().then((data: JS5Object) => {
                    pendingEditData.metadata.properties = data.deliveryItemEditViewFormData.deliveryItemDefaultMetadata;
                    return data;
                }));
            } else {
                editViewPromises.push(getDeliveryItem().then((deliveryItem: JS5Object) => {
                    pendingEditData = deliveryItem;
                }));
                editViewPromises.push(getFormData());
            }

            $q.all(editViewPromises).finally(() => {
                this.editData = pendingEditData;
                this.conversionTemplateVariableComponentsMap = MetadataService.buildCustomComponentMap(this.editData.metadata.properties);
                this.loadingIndicator.show = false;
            });
        });
    };

    this.$onDestroy = () => {
        PartnerEditService.originalEditData = null;
        PartnerEditService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
            BreadcrumbService.editService = PartnerEditService;
        });
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/delivery-item-edit-view-template.html',
    controller: DeliveryItemEditViewController,
    bindings: {
        isAdmin: '<',
        resolveData: '<'
    }
});
